import { render, staticRenderFns } from "./DialogAnnounceTypeDepartment.vue?vue&type=template&id=7c8b1e40&scoped=true&"
import script from "./DialogAnnounceTypeDepartment.vue?vue&type=script&lang=js&"
export * from "./DialogAnnounceTypeDepartment.vue?vue&type=script&lang=js&"
import style0 from "./DialogAnnounceTypeDepartment.vue?vue&type=style&index=0&id=7c8b1e40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8b1e40",
  null
  
)

export default component.exports